import { useEffect, useState } from "react";

export const useDebounceValue = (value: any, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState<any>(value);

  useEffect(() => {
    const t: NodeJS.Timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(t);
  }, [value, delay]);

  return debouncedValue;
};

export const useDebounceFunc = (func: () => void, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState<() => void>(func);

  useEffect(() => {
    const t: NodeJS.Timeout = setTimeout(() => {
      setDebouncedValue(func);
    }, delay);

    return () => clearTimeout(t);
  }, [func, delay]);

  return debouncedValue;
};
